import { map } from 'rxjs';

import { HttpResponse, type HttpEvent, type HttpInterceptorFn } from '@angular/common/http';

import { SKIP_API_ENVELOPE_UNWRAP } from '../tokens';
import { unwrapApiEnvelope, type ApiRawEnvelope } from '../api-envelope';

function looksLikeApiEnvelope(value: unknown): value is ApiRawEnvelope<unknown> {
  return !!value && typeof value === 'object' && ('payload' in value || 'service' in value);
}

export const unwrapApiEnvelopeInterceptor: HttpInterceptorFn = (request, next) => {
  const isJson = (request.responseType ?? 'json') === 'json';

  if (request.context.get(SKIP_API_ENVELOPE_UNWRAP) || !isJson) {
    return next(request);
  }

  return next(request).pipe(
    map((event: HttpEvent<unknown>) => {
      if (!(event instanceof HttpResponse)) {
        return event;
      }

      if (event.body == null || !looksLikeApiEnvelope(event.body)) {
        return event;
      }

      return event.clone({
        body: unwrapApiEnvelope(event.body),
      });
    }),
  );
};
